@if (room) {
  <div class="p-4">
    <avs-space-card-info
      [criticalAndMajorSeverityCount]="room.incidentCountBySeverity.critical + room.incidentCountBySeverity.major"
      [deviceActive]="room.devicesByStatuses.activeCount"
      [devicePaused]="room.devicesByStatuses.pausedCount"
      [minorSeverityCount]="room.incidentCountBySeverity.minor"
      [name]="room.friendlyName || room.name"
      [spaceLink]="allowNavigation ? ['/dashboard', locationId, floorId, room.id] : []"
      [status]="room.status"
    />
  </div>
}
